import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "../App.css"; // Ensure the correct file path
import { Pagination, Autoplay } from "swiper/modules";

// Import your skill icons (replace paths with actual files)
import angular from "../afbeeldingen/angular.jpg";
import css from "../afbeeldingen/css.png";
import html from "../afbeeldingen/html.png";
import javascript from "../afbeeldingen/java.png";
import php from "../afbeeldingen/php.png";
import react from "../afbeeldingen/react.png";
import dotnet from "../afbeeldingen/dotnet.png";
import python from "../afbeeldingen/python.png";
import java from "../afbeeldingen/javalogo.png";
import Progress from "../afbeeldingen/progress.jpg";

const Skills = () => {
  const skills = [
    { id: 1, name: "Angular", logo: angular },
    { id: 2, name: "CSS", logo: css },
    { id: 3, name: "HTML", logo: html },
    { id: 4, name: "JavaScript", logo: javascript },
    { id: 5, name: "PHP", logo: php },
    { id: 6, name: "React", logo: react },
    { id: 7, name: "Dotnet", logo: dotnet },
    { id: 8, name: "Python", logo: python },
    { id: 9, name: "Java", logo: java },
    { id: 9, name: "Progress Openedge", logo: Progress },
  ];

  return (
    <section className="skills text-center my-5">
      <h2 className="mb-4 .title">Skills</h2>
      <Swiper
        slidesPerView={5}
        spaceBetween={30}
        loop={true}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Autoplay]}
        className="mySwiper"
        grabCursor={true} // Enables grab cursor
        breakpoints={{
          1200: { slidesPerView: 5 }, // Desktop: 5 slides
          992: { slidesPerView: 4 },  // Medium screens: 4 slides
          768: { slidesPerView: 3 },  // Tablets: 3 slides
          576: { slidesPerView: 2 },  // Small screens: 2 slides
          0: { slidesPerView: 1 },    // Extra small screens: 1 slide
        }}
      >
        {skills.map((skill) => (
          <SwiperSlide key={skill.id}>
            <div
              className="skill-item d-flex flex-column align-items-center"
              style={{
                userSelect: "none", // Prevent text selection on the skill item
              }}
            >
              <img
                src={skill.logo}
                alt={skill.name}
                className="skill-logo mb-2"
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "contain",
                  userSelect: "none", // Prevent selection on image
                  pointerEvents: "none", // Ensure the image does not interfere with drag behavior
                }}
              />
              <div className="mb-4">
                <p style={{ cursor: "pointer", userSelect: "none" }}>{skill.name}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Skills;
